import {
    CLEAR_SIGNUP_ERROR,
    SIGNUP_ERROR,
    SIGNUP_PENDING,
    SIGNUP_PENDING_ERROR,
    SIGNUP_PENDING_SUCCESS,
    SIGNUP_SUCCESS,
    CLEAR_SIGNUP_SUCCESS_MESSAGE,
} from '../constants/signup.constants' ;

export const signupUserPending = () : Action => ({
    type: SIGNUP_PENDING,
});

export const signupUserError = (errorMessage: string): Action => ({
    type: SIGNUP_ERROR,
    payload: { errorMessage },
});

export const signupUserPendingError = (): Action => ({
    type: SIGNUP_PENDING_ERROR,
});
  
export const signupUserPendingSuccess = (): Action => ({
    type: SIGNUP_PENDING_SUCCESS,
});

export const clearSignupSuccessMessage = (): Action => ({
    type: CLEAR_SIGNUP_SUCCESS_MESSAGE,
});


export const signupUserSuccess = (
    email: string,
    token: string,
    expires: number
): Action => ({
    type: SIGNUP_SUCCESS,
    payload: { email, token, expires },
});

export const clearSignupUserError = (): Action => ({
    type: CLEAR_SIGNUP_ERROR,
});